export default {
    DARK_BLUE: '#35465c',
    BLUE: '#4c75aa',
    GRAY_BACKGROUND: '#f0f0f0',
    DARK_GRAY_BACKGROUND: '#DBDBDB',

}